import {
  BANK_DETAILS_LOADING,
  SET_BANK_DETAILS_FOR_USER,
  SET_BANK_DETAILS,
} from "./actionTypes";

const INIT_STATE = {
  data: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: [],
  },
  user_data: {},
  loading: false,
  isError: false,
};

const BankDetails = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_BANK_DETAILS_FOR_USER:
      return {
        ...state,
        user_data: action.payload,
      };
    case SET_BANK_DETAILS:
      return {
        ...state,
        data: action.payload,
      };
    case BANK_DETAILS_LOADING:
      return {
        ...state,
        loading: !state.loading,
      };
    default:
      return state;
  }
};

export default BankDetails;
